import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

const STATUS_LABEL = {
  planned: 'Planned', bred: 'Bred', confirmed_in_foal: 'In foal',
  not_in_foal: 'Not in foal', foaled: 'Foaled', lost: 'Lost',
};
const STATUS_BADGE = {
  planned: 'badge-gray', bred: 'badge-amber', confirmed_in_foal: 'badge-green',
  not_in_foal: 'badge-red', foaled: 'badge-primary', lost: 'badge-red',
};

const BreedingListPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [horse, setHorse] = useState(null);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const [h, r] = await Promise.all([
        api.get(`/horses/${id}`),
        api.get(`/breeding/horse/${id}`),
      ]);
      setHorse(h.data);
      setRecords(r.data);
    } catch (e) { toast.error('Failed to load'); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, [id]);

  const handleNew = async () => {
    try {
      const { data } = await api.post(`/breeding/horse/${id}`, { season_year: new Date().getFullYear(), status: 'planned' });
      navigate(`/horses/${id}/breeding/${data.id}`);
    } catch (e) { toast.error('Failed to create record'); }
  };

  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-secondary)', paddingBottom: 40 }}>
      <div className="top-bar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button onClick={() => navigate(`/horses/${id}`)} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', fontSize: 20, padding: '4px 8px 4px 0' }}>‹</button>
          <div style={{ flex: 1 }}>
            <h1 style={{ color: 'white', fontSize: 17 }}>Breeding</h1>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 12 }}>{horse?.name}</p>
          </div>
          <button onClick={handleNew} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white', cursor: 'pointer', fontSize: 13, borderRadius: 8, padding: '6px 14px', fontWeight: 500 }}>+ New</button>
        </div>
      </div>

      <div style={{ padding: 12 }}>
        {/* Mare reproductive history summary */}
        <div className="card" style={{ background: 'var(--cr-primary-light)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
            <h3 style={{ fontSize: 14 }}>Reproductive history</h3>
            <button onClick={() => navigate(`/horses/${id}/breeding/history`)} style={{ background: 'none', border: 'none', color: 'var(--cr-primary)', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>Edit</button>
          </div>
          <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
            Status: {horse?.repro_status || 'unknown'} · Foals: {horse?.repro_total_foals || 0} · Losses: {horse?.repro_losses || 0}
          </div>
          {horse?.repro_history_notes && <div style={{ fontSize: 12, marginTop: 6 }}>{horse.repro_history_notes}</div>}
        </div>

        {records.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">🐣</div>
            <h3>No breeding records</h3>
            <p>Start a record to track this season's breeding, pregnancy, and foaling.</p>
          </div>
        ) : (
          records.map(r => (
            <div key={r.id} className="card" style={{ cursor: 'pointer' }} onClick={() => navigate(`/horses/${id}/breeding/${r.id}`)}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{r.season_year || 'Season'} · {r.stallion_name || 'Stallion TBD'}</div>
                  <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 2 }}>
                    {r.breeding_date ? `Bred ${r.breeding_date}` : 'Not yet bred'}
                    {r.estimated_foaling_start ? ` · Due ${r.estimated_foaling_start} – ${r.estimated_foaling_end}` : ''}
                  </div>
                </div>
                <span className={`badge ${STATUS_BADGE[r.status] || 'badge-gray'}`}>{STATUS_LABEL[r.status] || r.status}</span>
              </div>
              {r.total_cost > 0 && <div style={{ fontSize: 12, color: 'var(--cr-primary)', marginTop: 8, fontWeight: 600 }}>Total cost: ${r.total_cost.toFixed(2)}</div>}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default BreedingListPage;
